import { render, staticRenderFns } from "./InformationType.vue?vue&type=template&id=1a9edcf8&scoped=true&"
import script from "./InformationType.vue?vue&type=script&lang=js&"
export * from "./InformationType.vue?vue&type=script&lang=js&"
import style0 from "./InformationType.vue?vue&type=style&index=0&id=1a9edcf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9edcf8",
  null
  
)

export default component.exports